import {Buffer} from "buffer";

export class PartialPacket {
    private _time: Date;
    private _partialIndex: string;
    private _value: string;
    private _hexValue: string;

    constructor(time: Date, partialIndex: string, value: string) {
        this._time = time;
        this._partialIndex = partialIndex;
        this._value = value;
        this._hexValue = Buffer.from(value, 'base64').toString('hex');
    }

    get time(): Date {
        return this._time;
    }

    get partialIndex(): string {
        return this._partialIndex;
    }

    get value(): string {
        return this._value;
    }

    get hexValue(): string {
        return this._hexValue;
    }

    get isErrorPacket(): boolean {
        return this._partialIndex.startsWith('E');
    }
}
